function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { CardBuilder } from "./Helpers/CardBuilder";
import { DateTimeFormatter } from "./Helpers/DateTimeFormatter";
import { PledgeUtils } from "./Helpers/PledgeUtils";
import { PledgeCampaignApiService } from "./Services/PledgeCampaignApiService";
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
export var MppMyPledges = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppMyPledges, _ComponentBase);

  var _super = _createSuper(MppMyPledges);

  function MppMyPledges() {
    _classCallCheck(this, MppMyPledges);

    return _super.call(this);
  }

  _createClass(MppMyPledges, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback() {
      if (!!this._$resultsContainer) {
        this.loadAttributes();
        this.GetMyPledges();
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.hideCancelButton = this.getAttribute("hidecancelbuttonpledge") || false;
      this.cancelPledgeEmailTemplate = this.getAttribute("cancelpledgeemailtemplate");
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("[mpp-my-pledges.js] Loading my pledges...");
                _context.next = 3;
                return new I18N(MppMyPledges.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this._root.innerHTML = "".concat(error);
                  }
                });

              case 3:
                i18n = _context.sent;
                this._i18n = i18n; // Load initial values of tag attributes:

                this.loadAttributes(); // Root Html

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mppw-form-wrapper" id="myPledgesWrapper" style="display: none;"><h1>${ i18n.pageTitle }</h1></div><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="emptyContainer" style="display: none;"></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div id="myPledgesNotLoggedIn" class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div class="resultsContainer mppw-card--grid" id="resultsContainer"></div></div>` ;
                this._$myPledgesWrapper = this._root.querySelector("#myPledgesWrapper");
                this._$resultsContainer = this._root.querySelector("#resultsContainer");
                this._$loadingContainer = this._root.querySelector("#loadingContainer");
                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
                this._$loginButton = this._root.querySelector("#loginButton");
                this._$cancelPledgeButtons = ''; // Will be set after getting data

                this._pledgesService = new PledgeCampaignApiService(); // Try logging in user

                this.TryLoginUser();

                this._$loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "TryLoginUser",
    value: function TryLoginUser() {
      var _this2 = this;

      UserService.GetCurrentUser().then(function (userInfo) {
        _this2._$loginButtonContainer.style.display = "none";
        _this2._$myPledgesWrapper.style.display = "";

        _this2.GetMyPledges();
      }, function () {
        _this2._$myPledgesWrapper.style.display = "none";
        _this2._$loginButtonContainer.style.display = "";
        _this2._$loadingContainer.style.display = "none";
      });
    }
  }, {
    key: "GetMyPledges",
    value: function GetMyPledges() {
      var _this3 = this;

      this._$resultsContainer.innerHTML = "";
      this._$loadingContainer.style.display = "";

      this._pledgesService.GetMyPledges().then(function (data) {
        if (data.length <= 0) {
          // No pledges associated to user
          _this3._$emptyContainer.style.display = "";
          _this3._$emptyContainer.innerHTML += "<div id=\"myPledgesEmpty\" class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(_this3._i18n.noPledgesFoundMessage ? _this3._i18n.noPledgesFoundMessage : 'No pledges found', "</span>\n\t\t\t\t\t\t</div>");
          _this3._$resultsContainer.innerHTML = '';
          _this3._$loadingContainer.style.display = "none";
        } else {
          // Loop through each group and build page with cards
          _this3._$emptyContainer.style.display = "none";
          var resultsContainerHTML = "";

          for (var i = 0; i < data.length; i++) {
            var _data$i = _objectSpread({}, data[i]),
                campaignGoal = _data$i.campaignGoal,
                campaignName = _data$i.campaignName,
                contactEmailAddress = _data$i.contactEmailAddress,
                contactFirstName = _data$i.contactFirstName,
                contactLastName = _data$i.contactLastName,
                contactNickname = _data$i.contactNickname,
                contactFriendlyName = _data$i.contactFriendlyName,
                endDate = _data$i.endDate,
                firstInstallmentDate = _data$i.firstInstallmentDate,
                imageUrl = _data$i.imageUrl,
                installmentsPlanned = _data$i.installmentsPlanned,
                pledge = _data$i.pledge,
                pledgeCampaignId = _data$i.pledgeCampaignId,
                pledgeDescription = _data$i.pledgeDescription,
                pledgeId = _data$i.pledgeId,
                pledgeStatus = _data$i.pledgeStatus,
                pledgeTotalToDate = _data$i.pledgeTotalToDate,
                pledgeTotalToDateString = _data$i.pledgeTotalToDateString,
                progress = _data$i.progress,
                showOnMyPledges = _data$i.showOnMyPledges,
                startDate = _data$i.startDate,
                totalPledge = _data$i.totalPledge,
                totalPledgeString = _data$i.totalPledgeString;

            var dtFormatter = new DateTimeFormatter();
            firstInstallmentDate = dtFormatter.ToShortDateFormatted(firstInstallmentDate, true);
            imageUrl = imageUrl ? imageUrl : null;
            var pledgeOwner = contactFirstName + " " + contactLastName;

            if (pledgeOwner == 'null null') {
              pledgeOwner = '';
            }

            var myPledgeDescription = installmentsPlanned + " installments beginning " + firstInstallmentDate;
            var progressBarPercentage = 0;

            if (pledgeTotalToDate > 0) {
              progressBarPercentage = pledgeTotalToDate >= totalPledge ? "100" : Math.trunc(pledgeTotalToDate / totalPledge * 100);
            }

            var progressBarText = pledgeTotalToDateString + " of " + totalPledgeString + " (" + progressBarPercentage + "%)";
            var showCancelButton = _this3.hideCancelButton === "false" && pledgeStatus == "Active";
            var subtitlesArr = CardBuilder.BuildGroupSubtitlesArr(pledgeOwner);
            var pledgeStatusBadgeText = !!pledgeStatus ? PledgeUtils.mapPledgeStatusToAppLabel(pledgeStatus, _this3._i18n) : '';
            resultsContainerHTML += CardBuilder.BuildCard( // Header
            CardBuilder.BuildBadge(true, pledgeStatusBadgeText) + CardBuilder.BuildImage(imageUrl, 'heart'), // Body
            CardBuilder.BuildText(campaignName, subtitlesArr, '') + CardBuilder.BuildProgress(progressBarText, progressBarPercentage, myPledgeDescription), // Footer
            showCancelButton === true ? CardBuilder.BuildDetailsButton(pledgeId, "#", _this3._i18n.cancelPledgeButtonText) : '');
          }

          _this3._$resultsContainer.innerHTML = resultsContainerHTML ? resultsContainerHTML : _this3._i18n.noPledgesFoundMessage;
          _this3._$loadingContainer.style.display = "none";
          _this3._$cancelPledgeButtons = _this3._$resultsContainer.querySelectorAll('.buildDetailsButton'); // Bind event listeners

          _this3.BindEventListeners();
        }
      })["catch"](function (error) {
        console.error(error);
        _this3._$loadingContainer.style.display = "none";
      });
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this4 = this;

      var _iterator = _createForOfIteratorHelper(this._$cancelPledgeButtons),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cancelButton = _step.value;
          cancelButton.addEventListener("click", function (e) {
            e.preventDefault();

            _this4.ConfirmCancelPledge(e.target.id);
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "ConfirmCancelPledge",
    value: function ConfirmCancelPledge(pledgeId) {
      var _this5 = this;

      if (pledgeId) {
        var confirmResult = confirm("Are you sure you would like to cancel this pledge?");

        if (confirmResult === true) {
          // Cancel
          this._pledgesService.CancelMyPledge(pledgeId, this.cancelPledgeEmailTemplate).then(function (data) {
            // Pledge cancelled
            _this5.GetMyPledges();
          })["catch"](function (error) {
            console.error(error);
          });
        } else {// Do not cancel
        }
      }
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "My Pledges",
        tag: "mpp-my-pledges",
        configurationItems: [{
          name: "Hide Cancel Button",
          attribute: "hidecancelbuttonpledge",
          description: "Determines whether the option to cancel an active Pledge is displayed (Default: true).",
          required: false,
          type: "bool"
        }, {
          name: "Cancel Pledge Email Template",
          attribute: "cancelpledgeemailtemplate",
          description: "Confirmation email that is sent after a User has successfully cancelled an active Pledge. Valid value: Message ID (Note: If Hide Cancel Button = false, this value must be configured).",
          required: false,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["hidecancelbuttonpledge", "cancelpledgeemailtemplate"];
    }
  }]);

  return MppMyPledges;
}(ComponentBase);
MppMyPledges.registerComponent(MppMyPledges.WidgetDetails.tag, MppMyPledges);